<template>
  <div class="container">
    <div class="video-player">
      <video id="video" class="video-class" controls autoplay muted playsinline @play="playEvent">
        您的浏览器不支持视频播放
      </video>
      <div class="loading-div" v-if="loading">
        <van-loading v-if="errorMsg == null" type="spinner" />
        <div class="error" v-else>{{ errorMsg }}</div>
      </div>
    </div>

    <div class="tip-container">
      <div class="yt-title">云台控制</div>
      <div class="sub">请通过操控云台来调整摄像机视角</div>
    </div>

    <div class="yt-container">
      <div class="mobile-ez-ptz-container" id="mobile-ez-ptz-container">
        <div class="ez-ptz-main center" @click="ptz('stop')"></div>
        <div class="mobile-ez-ptz-icon top default" @click="ptz('up')"></div>
        <div class="mobile-ez-ptz-icon left default" @click="ptz('left')"></div>
        <div class="mobile-ez-ptz-icon bottom default" @click="ptz('down')"></div>
        <div class="mobile-ez-ptz-icon right default" @click="ptz('right')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { preview, ptzControl } from "@/api/player";

let webrtcPlayer = null
export default {
  data() {
    return {
      loading: true,
      errorMsg: null,
      videoUrl:'',
      startPlayTime: null,  //开始播放时间
      maxPlayTime: 10 * 60,  //远程预览最大时长：10分钟
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.pause()
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.stopRemotePlayerTimer()
  },
  methods: {
    init() {
      const query = this.$route.query
      this.token = query.accessToken
      this.cameraId = query.cameraId
      const cameraName = query.name
      if (cameraName) {
        document.title = cameraName + ""
      }
      this.isIos = query.ios == 1
      if (!this.token || !this.cameraId) {
        this.errorMsg = "未传递有效参数"
        return
      }
      preview(this.token, this.cameraId).then(res => {
        console.log(res)
        if (res.code && res.data) {
          this.videoUrl = res.data.rtc
          this.play()
        } else {
          this.errorMsg = res.message
        }
      }).catch(res => {
        this.errorMsg = res.message
      })
    },
    playEvent() {
      this.loading = false
    },
    play: function () {
      webrtcPlayer = new ZLMRTCClient.Endpoint({
        element: document.getElementById("video"),
        debug: false,// 是否打印日志
        zlmsdpUrl: this.videoUrl,//zlm流地址
        useCamera: false,
        audioEnable: false,
        videoEnable: false,
        recvOnly: true
      })
      webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, (e) => {// ICE 协商出错
        this.error('ICE ERROR', 'ICE 协商出错')
      })

      webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_ON_REMOTE_STREAMS, (e) => {//获取到了远端流，可以播放
        console.log('playing', '播放成功:' + e.streams)
        // ios设备需要等待加载一会后再播放
        if (this.isIos) {
          const video = document.getElementById("video")
          setTimeout(() => {
            video.play()
          }, 1000)
          setTimeout(() => {
            video.pause()
          }, 3000)
          setTimeout(() => {
            video.play()
          }, 5000)
        }

        this.startPlayTime = new Date()
        this.startRemotePlayerTimer()
      })

      webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, (e) => {// offer anwser 交换失败
        this.error('OFFER ANSWER ERROR ', 'offer answer 交换失败')
      })
    },
    pause: function () {
      if (webrtcPlayer != null) {
        webrtcPlayer.close()
        webrtcPlayer = null
        console.log('RTC播放结束')
      }
    },
    error: function (type, message) {
      console.log('player 事件回调:', type, '---->', message)
      this.errorMsg = "远程播放失败，请重试~"
    },
    // 云台控制命令
    ptz(cmd) {
      ptzControl(this.token, this.cameraId, cmd)
        .then(res => {
          console.log("云台控制结果：{}", res)
        })
      this.vibrate()
    },
    // 让设备震动
    vibrate() {
      navigator.vibrate = navigator.vibrate ||
        navigator.webkitVibrate ||
        navigator.mozVibrate ||
        navigator.msVibrate;
      if (navigator.vibrate) {
        navigator.vibrate([100, 20]);
      }
    },
    // 远程播放计时开始
    startRemotePlayerTimer() {
      if (this.remotePlayerTimer != null) {
        return;
      }
      console.log("远程播放，开始进行播放时长定时任务...")
      this.remotePlayerTimer = setInterval(() => {
        const now = new Date()
        const dist = now.getTime() - this.startPlayTime.getTime()
        console.log("dist:", dist)
        if (dist / 1000 > this.maxPlayTime) {
          console.log("远程播放，已超出最大播放时长，自动关闭监控视频播放")
          this.pause()
          this.stopRemotePlayerTimer()
          this.loading = true
          this.errorMsg = "远程预览已超过最大时长~"
        }
      }, 5000);
    },
    stopRemotePlayerTimer() {
      if (this.remotePlayerTimer != null) {
        clearInterval(this.remotePlayerTimer)
        this.remotePlayerTimer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-player {
  width: 100%;
  position: relative;

  .video-class {
    width: 100%;
    height: 30vh;
    background-color: #000;
  }

  .loading-div {
    position: absolute;
    background-color: #000;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .error {
      font-size: 16px;
      color: red;
    }

  }
}

.tip-container {
  text-align: center;

  .yt-title {
    height: 25px;
    font-size: 18px;
    color: #2c2c2c;
    text-align: center;
    font-weight: 700;
    margin: 24px 0 12px;
  }

  .sub {
    margin-bottom: 24px;
    color: #aaaaaa;
  }
}

.yt-container {
  display: inline-block;
  padding: 24px 24px;
  border-radius: 100%;
  overflow: hidden;
  background-image: linear-gradient(180deg, #f6f8ff 0%, #ededed6b 50%);

}

#mobile-ez-ptz-container {
  //display: inline-block;
  //width: 100%;
  text-align: center;
}


.mobile-ez-ptz-container {
  position: relative;
  width: 260px;
  height: 260px;
  background: rgba(255, 255, 255, 0.80);
  border: 1px solid rgba(255, 255, 255, 0.80);
  border-radius: 100%;
  cursor: pointer;
  overflow: hidden;
  margin: auto;

  .ez-ptz-main.center {
    width: 52px;
    height: 52px;
    background: #FFFFFF;
    border: 2px solid #eee;
    border-radius: 100%;
    top: calc(50% - 26px);
    left: calc(50% - 26px);
    position: absolute;
    /* box-shadow: 0px -39px 40px 6px #1890ff; */
  }

  .mobile-ez-ptz-icon.top {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #aaaaaa;
    position: absolute;
    display: inline-block;
    left: calc(50% - 6px);
    top: 10px;
  }

  .mobile-ez-ptz-icon.top:active {
    border-bottom: 6px solid #1e90ff;
  }

  .mobile-ez-ptz-icon.left {
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #aaaaaa;
    position: absolute;
    display: inline-block;
    top: calc(50% - 6px);
    left: 10px;
  }

  .mobile-ez-ptz-icon.left:active {
    border-right: 6px solid #1e90ff;
  }

  .mobile-ez-ptz-icon.bottom {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #aaaaaa;
    position: absolute;
    display: inline-block;
    left: calc(50% - 6px);
    bottom: 10px;
  }

  .mobile-ez-ptz-icon.bottom:active {
    border-top: 6px solid #1e90ff;
  }

  .mobile-ez-ptz-icon.right {
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #aaaaaa;
    position: absolute;
    display: inline-block;
    top: calc(50% - 6px);
    right: 10px;
  }

  .mobile-ez-ptz-icon.right:active {
    border-left: 6px solid #1e90ff;
  }
}
</style>
